import { useState, useCallback } from 'react';

// Copy-to-clipboard with a short "copied" flash. Shared by the message action row.
export const useCopy = (resetMs = 2000) => {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(
    async (text) => {
      const value = text ?? '';
      if (!value) return;
      try {
        await navigator.clipboard.writeText(value);
      } catch {
        // Fallback for browsers without the async Clipboard API / insecure contexts.
        const ta = document.createElement('textarea');
        ta.value = value;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy');
        } catch {
          /* noop */
        }
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), resetMs);
    },
    [resetMs]
  );

  return { copied, copy };
};

export default useCopy;
